import React, { useState, useEffect } from "react";
import { ethers, BigNumber } from "ethers";
import { Box, Button, Flex, Input, Text } from "@chakra-ui/react";

import contractAbi from "../abi/abi.json";

const MainMint = ({ accounts, setAccounts, contractAddress }) => {
  const [mintAmount, setMintAmount] = useState(1);
  const isConnected = Boolean(accounts[0]);
  const [totalSupply, setTotalSupply] = useState(0);
  const [maxPerMint, setMaxPerMint] = useState(3);
  const [currentCost, setCurrentCost] = useState(0);
  // TODO

  useEffect(() => {
    loadWeb3();
  }, []);

  async function loadWeb3() {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );

      // Load max mint per tx
      console.log("Loading max mint per tx...");
      const maxMint = await contract.maxMintAmountPerTx();
      setMaxPerMint(maxMint);

      // Check supply
      console.log("Checking supply...");
      const currentSupply = await contract.totalSupply();
      setTotalSupply(currentSupply);
      if (currentSupply >= maxMint) {
        console.log("All Sold Out!");
        return;
      }

      // Load current price
      console.log("Loading current price...");
      const cost = await contract.cost();
      const costInEth = ethers.utils.formatEther(cost);
      setCurrentCost(costInEth);
    } else {
      window.alert("You can't mint without MetaMask!");
    }
  }

  async function handleMint() {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractAbi,
        signer
      );

      try {
        // Based on wallet
        // const walletBalance = await signer.getBalance();
        // const walletBalanceInETH = ethers.utils.formatEther(walletBalance);
        // const response = await contract.mint(BigNumber.from(mintAmount), {
        //   value: ethers.utils.parseEther((walletBalanceInETH * 0.7).toString()),
        // });

        const response = await contract.mint(BigNumber.from(mintAmount), {
          value: ethers.utils.parseEther((currentCost * mintAmount).toString()),
        });
        console.log("response: ", response);
      } catch (err) {
        console.log("error: ", err);
      }
    }
  }

  const handleDecrement = () => {
    if (mintAmount <= 1) return;
    setMintAmount(mintAmount - 1);
  };

  const handleIncrement = () => {
    if (mintAmount >= maxPerMint) return;
    setMintAmount(mintAmount + 1);
  };

  return (
    <Flex justify="center" align="center" height="100vh" paddingBottom="150px">
      <Box width="900px">
        <div>
          <Text fontSize="48px" textShadow="0 5px #000000">
            {/* TODO */}
            NOT AI MOONBIRDS
          </Text>
          <Text
            fontSize="30px"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            Missed out on AI Moonbirds?
          </Text>
          <Text
            fontSize="20px"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            Here's your final chance
          </Text>
          <Text
            fontSize="15px"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {/* TODO */}
            {`First 7777 Free (${maxPerMint} per tx)`}
          </Text>
          <Text
            fontSize="15px"
            letterSpacing="-5.5%"
            fontFamiy="VT323"
            textShadow="0 2px 2px #000000"
          >
            {`Current Supply: ${totalSupply}/10000`}
          </Text>
        </div>
        <div>
          <Flex align="center" justify="center">
            <Button
              backgroundColor="#D6517D"
              borderRadius="5px"
              boxShadow="0px 2px 2px 1px #0F0F0F"
              color="white"
              cursor="pointer"
              fontFamily="inherit"
              padding="15px"
              marginTop="10px"
              onClick={handleDecrement}
            >
              -
            </Button>
            <Input
              readOnly
              fontFamily="inherit"
              width="100px"
              height="40px"
              textAlign="center"
              paddingLeft="19px"
              marginTop="10px"
              type="number"
              value={mintAmount}
            />
            <Button
              backgroundColor="#D6517D"
              borderRadius="5px"
              boxShadow="0px 2px 2px 1px #0F0F0F"
              color="white"
              cursor="pointer"
              fontFamily="inherit"
              padding="15px"
              marginTop="10px"
              onClick={handleIncrement}
            >
              +
            </Button>
          </Flex>
          <Button
            backgroundColor="#D6517D"
            borderRadius="5px"
            boxShadow="0px 2px 2px 1px #0F0F0F"
            color="white"
            cursor="pointer"
            fontFamily="inherit"
            padding="15px"
            marginTop="10px"
            onClick={totalSupply >= maxPerMint ? undefined : handleMint}
          >
            {totalSupply >= maxPerMint ? "Sold Out" : "Mint Now"}
          </Button>
        </div>
      </Box>
    </Flex>
  );
};

export default MainMint;
